import api from "../factory/api"

export const createClient = async (body = {}) => {
    try {
        let { data } = await api.post("/clients", body)

        return data
    } catch (error) {
        throw error
    }
}